import { Navigate, Route, Routes } from 'react-router-dom';

import LoginPage from '../core/auth/LoginPage';
import TeacherLoginPage from '../core/auth/TeacherLoginPage';
import ProtectedRoute from '../core/router/ProtectedRoute';
import AppShell from '../components/layout/AppShell';

import LandingPage from '../modules/landing/LandingPage';
import DashboardPage from '../modules/dashboard/DashboardPage';
import RegistrationsPage from '../modules/registrations/RegistrationsPage';
import PublicRegistrationPage from '../modules/registrations/PublicRegistrationPage';
import StudentsPage from '../modules/students/StudentsPage';
import ParentsPage from '../modules/parents/ParentsPage';
import EmployeesPage from '../modules/employees/EmployeesPage';
import TeacherDetailPage from '../modules/teachers/TeacherDetailPage';
import ClassesPage from '../modules/classes/ClassesPage';
import FinancePage from '../modules/finance/FinancePage';
import TasksPage from '../modules/tasks/TasksPage';
import CommunicationPage from '../modules/communication/CommunicationPage';
import AnnouncementsAdminPage from '../modules/communication/AnnouncementsAdminPage';
import HrPage from '../modules/hr/HrPage';
import DocumentsPage from '../modules/documents/DocumentsPage';
import ReportsPage from '../modules/reports/ReportsPage';
import SettingsPage from '../modules/settings/SettingsPage';
import ParentPortal from '../modules/parents/ParentPortal';
import TeacherPortal from '../modules/teacher/TeacherPortal';
import TeacherClassPage from '../modules/teacher/TeacherClassPage';
import TeacherHomeworkPage from '../modules/teacher/TeacherHomeworkPage';
import HomeworkValidationPage from '../modules/homework/HomeworkValidationPage';
import SchoolSuppliesPage from '../modules/supplies/SchoolSuppliesPage';

import { PERMISSIONS } from '../core/permissions/roles';

const protectedAdminPage = (permission, element) => (
  <ProtectedRoute accountType="administration" permission={permission}>
    {element}
  </ProtectedRoute>
);

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/connexion-enseignant" element={<TeacherLoginPage />} />
      <Route path="/demande-inscription" element={<PublicRegistrationPage />} />

      <Route
        path="/parent/*"
        element={
          <ProtectedRoute accountType="parent">
            <ParentPortal />
          </ProtectedRoute>
        }
      />

      <Route
        path="/enseignant"
        element={
          <ProtectedRoute accountType="teacher">
            <TeacherPortal />
          </ProtectedRoute>
        }
      />
      <Route
        path="/enseignant/classes/:classId"
        element={
          <ProtectedRoute accountType="teacher">
            <TeacherClassPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/enseignant/travail"
        element={
          <ProtectedRoute accountType="teacher">
            <TeacherHomeworkPage />
          </ProtectedRoute>
        }
      />

      <Route
        element={
          <ProtectedRoute accountType="administration">
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={protectedAdminPage(PERMISSIONS.DASHBOARD_VIEW, <DashboardPage />)} />
        <Route path="/inscriptions" element={protectedAdminPage(PERMISSIONS.REGISTRATIONS_VIEW, <RegistrationsPage />)} />
        <Route path="/eleves" element={protectedAdminPage(PERMISSIONS.STUDENTS_VIEW, <StudentsPage />)} />
        <Route path="/parents" element={protectedAdminPage(PERMISSIONS.PARENTS_VIEW, <ParentsPage />)} />
        <Route path="/personnel" element={protectedAdminPage(PERMISSIONS.EMPLOYEES_VIEW, <EmployeesPage />)} />
        <Route path="/personnel/equipe-pedagogique/:teacherId" element={protectedAdminPage(PERMISSIONS.EMPLOYEES_VIEW, <TeacherDetailPage />)} />
        <Route path="/enseignants" element={<Navigate to="/personnel?view=teachers" replace />} />
        <Route path="/classes" element={protectedAdminPage(PERMISSIONS.CLASSES_VIEW, <ClassesPage />)} />
        <Route path="/finance" element={protectedAdminPage(PERMISSIONS.FINANCE_STUDENT_LOOKUP, <FinancePage />)} />
        <Route path="/taches" element={protectedAdminPage(PERMISSIONS.TASKS_VIEW, <TasksPage />)} />
        <Route path="/communication" element={protectedAdminPage(PERMISSIONS.COMMUNICATION_VIEW, <CommunicationPage />)} />
        <Route path="/annonces" element={protectedAdminPage( PERMISSIONS.COMMUNICATION_VIEW,<AnnouncementsAdminPage />
  )}
/>
        <Route
        path="/annonces"
        element={protectedAdminPage(
        PERMISSIONS.COMMUNICATION_VIEW,
       <AnnouncementsAdminPage />
       )}
       />
        <Route path="/rh" element={protectedAdminPage(PERMISSIONS.HR_VIEW, <HrPage />)} />
        <Route path="/documents" element={protectedAdminPage(PERMISSIONS.DOCUMENTS_VIEW, <DocumentsPage />)} />
        <Route path="/rapports" element={protectedAdminPage(PERMISSIONS.REPORTS_VIEW, <ReportsPage />)} />
        <Route path="/parametres" element={protectedAdminPage(PERMISSIONS.SETTINGS_MANAGE, <SettingsPage />)} />
        <Route path="/travaux-validation" element={protectedAdminPage(PERMISSIONS.HOMEWORK_VALIDATE, <HomeworkValidationPage />)} />
        <Route path="/fournitures-scolaires" element={protectedAdminPage(PERMISSIONS.SCHOOL_SUPPLIES_MANAGE, <SchoolSuppliesPage />)} />
      </Route>

      <Route
        path="/403"
        element={
          <main className="screen-center">
            <div className="panel empty-state">
              <strong>Accès refusé</strong>
              <p>Votre rôle ne permet pas d’ouvrir ce module.</p>
            </div>
          </main>
        }
      />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
